var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocuments = function SvgDocuments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    viewBox: "0 0 256.61 256.61"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.859 112.533c-6.853 0-6.853 10.646 0 10.646h81.875c6.865 0 6.865-10.646 0-10.646zM142.734 137.704H60.859c-6.853 0-6.853 10.634 0 10.634h81.875c6.866 0 6.866-10.634 0-10.634M142.734 161.018H60.859c-6.853 0-6.853 10.633 0 10.633h81.875c6.866-.001 6.866-10.633 0-10.633M142.734 186.184H60.859c-6.853 0-6.853 10.629 0 10.629h81.875c6.866-.001 6.866-10.629 0-10.629M141.17 209.934H59.28c-6.848 0-6.848 10.633 0 10.633h81.89c6.845-.001 6.845-10.633 0-10.633"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.362 58.087V256.61h152.877V85.63l-28.406-27.543zm139.664 185.306H38.585V71.305h104.443v20.97h21.988v151.118z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.204 27.667v22.978h13.223V40.88h104.448v20.97h21.993v151.121h-5.809v13.217h19.027V55.205L175.68 27.667z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M202.837 0H78.363v22.983h13.218v-9.765h104.451v20.97h21.993v151.118h-5.804v13.217h19.027V27.543z"
  })));
};
export default SvgDocuments;